import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ListItem, ListItemText, makeStyles, Typography } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import { useLocationActive } from '../../../../hooks/useLocationActive';
import { pxToRem, transitionSpeed } from '../../../../theme';
import { Badge } from '../Badge';
const useStyles = makeStyles((theme) => ({
    chevron: {
        color: theme.palette.primary.main,
        transition: `transform ${transitionSpeed} ease-out`,
    },
    chevronCollapsed: {
        transform: 'rotate(90deg)',
    },
    secondaryLink: {
        borderRadius: '4px',
        color: theme.palette.text.secondary,
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(0, 0, 0, 1),
        textDecoration: 'none',
        transition: `background-color ${transitionSpeed} ease-out`,
        width: '100%',
        '&:hover, &:focus': {
            backgroundColor: theme.palette.brand.sky50,
        },
        '&.active': {
            backgroundColor: theme.palette.primary.light,
            '& .MuiTypography-root': {
                fontWeight: 600,
            },
            '& .chevron': {
                transform: 'rotate(90deg)',
            },
        },
        '&.hasSublinks': {
            color: theme.palette.primary.main,
            '& .MuiTypography-root': {
                fontWeight: '500 !important',
                textTransform: 'uppercase',
            },
        },
        '&.tertiaryActive': {
            background: 'none',
            fontSize: pxToRem(12),
            fontWeight: 500,
        },
    },
    secondaryNavItem: {
        marginBottom: theme.spacing(0.5),
        padding: theme.spacing(0, 2, 0, 0),
    },
    secondaryNavText: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.spacing(0, 0.5, 0, 0),
        textTransform: 'none',
        transition: `opacity ${transitionSpeed} ease-out`,
    },
    secondaryNavTextCollapsed: {
        opacity: 0,
    },
}));
/**
 * Sub link item for the `LeftNav` component.
 *
 * @param {boolean} props.isMenuOpen - Indicates whether the left navigation is open or not.
 * @param {string} props.text - The text to be displayed for the sub link.
 * @returns {JSX.Element} The rendered `SubLink` item.
 */
export function SubLink({ isCollapsed, isMenuOpen, status, subLinks, testId, text, url, onClick }) {
    const classes = useStyles();
    const { isActive, isAnySubLinkActive } = useLocationActive();
    const hasSublinks = subLinks !== undefined;
    const hasTertiaryLinkActive = hasSublinks ? isAnySubLinkActive(subLinks) : false;
    const onLinkClick = (e) => {
        e.stopPropagation();
        onClick(e);
    };
    return (_jsx(ListItem, { className: classes.secondaryNavItem, component: 'li', children: _jsxs(NavLink, { className: clsx(classes.secondaryLink, {
                active: isActive(url),
                tertiaryActive: hasTertiaryLinkActive,
                hasSublinks,
            }), "data-testid": testId, to: url, onClick: onLinkClick, children: [_jsx(ListItemText, { children: _jsxs(Typography, { className: clsx(classes.secondaryNavText, {
                            [classes.secondaryNavTextCollapsed]: !isMenuOpen,
                        }), children: [text, status && _jsx(Badge, { shouldShowDot: !isMenuOpen, status: status })] }) }), hasSublinks && (_jsx(ChevronRight, { className: clsx(classes.chevron, 'chevron', {
                        [classes.chevronCollapsed]: hasTertiaryLinkActive || isCollapsed,
                    }) }))] }) }));
}
